import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Notifications_ds_get_exported_invoicesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { from_date: string, projectId?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ModifiedSysDateTime?: string, ProjectId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.from_date)) {
      $missingRequiredInParams.push('\'from_date\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { from_date: string, projectId?: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ModifiedSysDateTime?: string, ProjectId?: number }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.from_date)) {
      $missingRequiredInParams.push('\'from_date\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { from_date: string, projectId?: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, LookupCode?: string, ModifiedSysDateTime?: string, ProjectId?: number }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.from_date)) {
      $missingRequiredInParams.push('\'from_date\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      from_date: string, projectId?: number    }) {
        if(isNil($inParams.from_date)) {
          return true; 
        }
      return false;
    }
}
